<template>

    <div>

        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-6">
        </base-header>
        
        <div class="container-fluid mt--7">
            <div class="btn-group" role="group" style="width:100%;" >
                <button type="button" class="btn btn-primary" v-on:click="selectChart('Biologics')">Biologics</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('CPGuaranteeInsured')">Carepoint Guarantee Pricing (Insured)</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('GenericCash')">Generic Cash Pricing</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('Dermatology')">Derm Prices</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('Podietry')">Pod Prices</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('NumAndPsych')">Neuro Prices</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('Respiratory')">Pulmo Prices</button>
                <button type="button" class="btn btn-primary" v-on:click="selectChart('Rheumotology')">Rheum Prices</button>
            </div>
            <pricing-charts :selectedChart="selectedChart"></pricing-charts>
        </div>

    </div>
</template>
<script>
    // Charts
    import PricingCharts from '@/components/Charts/PricingCharts';

    export default {
        components: {
            PricingCharts,
        },
        data() {
            return {
                selectedChart: 'Biologics'
            };
        },
        methods: {
            selectChart(chart) {
                this.selectedChart = chart
            }
        },
        mounted() {
        }
    };
</script>
<style></style>
